<div
  [class.current-user]="isCurrentViewer"
  [class.other-user]="!isCurrentViewer"
  class="message mat-elevation-z2"
>
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <h3>
      <strong>{{ senderName$ | async }}</strong>
    </h3>
    <h4>{{ dateDisplay }}</h4>
  </div>

  <p class="message">{{ conversationMessage.message }}</p>
</div>
